import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import TableNestedLandSubLotObjects from "./TableNestedLandSubLotObjects";
import TableNestedLandSubLots from "./TableNestedLandSubLots";

export default function LandLotComposition() {
    return (
        <>
            <ContentHeader title="Состав земельного" type="simple" />
            <TableNestedLandSubLots />
            <TableNestedLandSubLotObjects />
        </>
    )
}
